const parseHtmlCharCodes = (str) => {
  return str.replace(/(&#(\d+);)/g, (match, capture, charCode) => {
    return String.fromCharCode(charCode);
  });
};

export default parseHtmlCharCodes;
